import React, { Component } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { setSelectedMenu } from '../../actions/commonActions';
import ReportManagementView from './containers/ReportManagementView';

class ReportHome extends Component {
    constructor(props) {
        super(props);
        this.props.setSelectedMenu(['report']);
    }

    getView = (route) => {
        switch (route.match.params.page) {
            default:
                return <ReportManagementView />;
        }
    }

    render() {
        return (
            <Switch>
                <Route path={'/report'} render={this.getView} />
                <Redirect to='/report' />
            </Switch>
        )
    }

}

function mapStateToProps(state, props) {
    return {
        userId: state.getIn(["loginUserState", "userId"]),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setSelectedMenu: bindActionCreators(setSelectedMenu, dispatch)
    }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportHome));